import React, { useMemo, useState } from 'react';
import Modal from 'react-modal';
import './Favoritos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHeart } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import { useCatalogData } from '../CatalogData/CatalogDataProvider';
import moneda from '../moneda';

const FAVORITES_STORAGE_KEY = 'favoritos';

const leerFavoritosGuardados = () => {
    try {
        const favoritosGuardados = JSON.parse(localStorage.getItem(FAVORITES_STORAGE_KEY));
        return Array.isArray(favoritosGuardados) ? favoritosGuardados : [];
    } catch {
        return [];
    }
};

export default function Favoritos() {
    const [favoritos, setFavoritos] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const {
        productos,
        status,
        errors,
        ensureProductos,
        retryProductos,
    } = useCatalogData();
    const necesitaProductos = modalIsOpen && favoritos.length > 0;
    const loading = necesitaProductos
        && (status.productos === 'idle' || status.productos === 'loading');
    const catalogError = necesitaProductos
        && (status.productos === 'error' || Boolean(errors.productos));
    const productosFavoritos = useMemo(() => (
        favoritos
            .map(id => productos.find(producto => producto.idProducto === id))
            .filter(Boolean)
    ), [favoritos, productos]);

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        const favoritosGuardados = leerFavoritosGuardados();
        setFavoritos(favoritosGuardados);
        setModalIsOpen(true);

        if (favoritosGuardados.length === 0) {
            return;
        }

        const productsRequest = status.productos === 'error'
            ? retryProductos()
            : status.productos === 'idle'
                ? ensureProductos()
                : null;

        productsRequest?.catch(() => {});
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleRetry = () => {
        retryProductos().catch(() => {});
    };

    const eliminarProducto = (id) => {
        const updatedFavoritos = favoritos.filter(itemId => itemId !== id);
        setFavoritos(updatedFavoritos);
        localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(updatedFavoritos));
    };

    return (
        <div>
            <button type="button" onClick={openModal} className='cartIcon' aria-label="Abrir favoritos" title="Favoritos"><FontAwesomeIcon icon={faHeart} /></button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
                contentLabel="Favoritos"
            >
                <div className='deFLex'>
                    <button type="button" onClick={closeModal} aria-label="Cerrar favoritos"><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <button type="button" onClick={closeModal} className='deleteToCart' aria-label="Cerrar lista de favoritos">Favoritos</button>
                </div>
                {favoritos?.length === 0 ? (
                    <p className='nohay'>No hay favoritos</p>
                ) : (
                    <div className="modal-content-cart">
                        {loading ? (
                            <p>Cargando...</p>
                        ) : catalogError ? (
                            <div>
                                <p role="alert">No fue posible cargar tus favoritos.</p>
                                <button type="button" onClick={handleRetry}>Reintentar</button>
                            </div>
                        ) : (
                            <div>
                                {productosFavoritos.map((producto) => (
                                    <div key={producto.idProducto} className='cardProductCart' >
                                        <Anchor to={`/producto/${producto?.idProducto}/${producto?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal} aria-label={`Ver producto ${producto.titulo}`} >
                                            <img src={obtenerImagen(producto)} alt={producto.titulo} loading="lazy" decoding="async" />
                                        </Anchor>
                                        <div className='cardProductCartText'>
                                            <h3>{producto.titulo}</h3>
                                            <span>{producto.categoria}</span>
                                            <strong> {moneda} {producto?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>

                                        </div>
                                        <button type="button" onClick={() => eliminarProducto(producto.idProducto)} className='deleteFav' aria-label={`Quitar ${producto.titulo} de favoritos`} title="Quitar de favoritos"><FontAwesomeIcon icon={faHeart} /></button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </Modal>
        </div>
    );
}
